<template>
  <v-dialog v-model="value" max-width="600px">
    <v-card>
      <v-card-title class="primary modal-title">
        <span>Convidar Usuário para Responder</span>
        <v-spacer/>
        <v-btn icon @click="fecharModal">
          <v-icon size="20" color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-tabs v-model="activeTab">
          <v-tab>Convidar Usuário</v-tab>
          <v-tab>Usuários Convidados</v-tab>

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <usuario-autocomplete
                  v-model="usuarioSelecionado"
                  :esclarecimento-impugnacao-id="esclarecimentoImpugnacaoId"
                  @error="handleError"
                />
              </v-card-text>
              <div class="az-actions-form actions-modal">
                <button class="action-secundary-button" @click="fecharModal">Cancelar</button>
                <button 
                  class="action-primary-button" 
                  @click="convidarUsuario" 
                  :disabled="!usuarioSelecionado">
                  Convidar
                </button>
              </div>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="usuariosConvidados"
                  :loading="carregandoUsuariosConvidados"
                  hide-actions
                  class="az-table-list table-usuarios-convidados"
                >
                  <template slot="items" slot-scope="props">
                    <tr>
                      <td>{{ props.item.nome }}</td>
                      <td>{{ props.item.email }}</td>
                      <td>
                        <v-chip
                          :color="getSituacaoColor(props.item.situacaoConvite)"
                          text-color="white"
                          small
                        >
                          {{ props.item.situacaoConvite }}
                        </v-chip>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
                <v-flex xs12 sm12 d-flex v-if="!carregandoUsuariosConvidados && usuariosConvidados.length === 0">
                  <az-ops title="Nenhum usuário convidado encontrado."
                          message="Não há usuários convidados para responder este esclarecimento/impugnação."
                  ></az-ops>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { actionTypes } from '@/commons/constants'
import UsuarioAutocomplete from './UsuarioAutocomplete'

export default {
  name: 'ModalConvidarUsuarioParaResponderEsclarecimentoImpugnacao',
  components: {
    UsuarioAutocomplete
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    esclarecimentoImpugnacaoId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      usuarioSelecionado: null,
      usuariosConvidados: [],
      carregandoUsuariosConvidados: false,
      activeTab: 0
    }
  },
  computed: {
    headers() {
      return this.criarColunas(3,
        ['Nome', 'Email', 'Situação'],
        ['nome', 'email', 'situacaoConvite'],
        [false, false, false],
        ['left', 'left', 'left'],
        ['40%', '40%', '20%'],
        'primary--text')
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.buscarUsuariosConvidados();
      }
    },
    activeTab(newVal) {
      if (newVal === 1) {
        this.buscarUsuariosConvidados();
      }
    }
  },

  mounted() {
    if (this.value) {
      this.buscarUsuariosConvidados();
    }
  },
  methods: {
    ...mapActions([
      actionTypes.CONVIDAR_USUARIO_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO,
      actionTypes.BUSCAR_USUARIOS_CONVIDADOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO
    ]),
    fecharModal() {
      this.$emit('input', false)
      this.usuarioSelecionado = null
      this.activeTab = 0
    },

    async buscarUsuariosConvidados() {
      this.carregandoUsuariosConvidados = true
      try {
        const data = await this[actionTypes.BUSCAR_USUARIOS_CONVIDADOS_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO](this.esclarecimentoImpugnacaoId)
        this.usuariosConvidados = data.usuarios || []
      } catch (error) {
        this.handleError('Erro ao buscar usuários convidados')
      } finally {
        this.carregandoUsuariosConvidados = false
      }
    },

    getSituacaoColor(situacao) {
      switch (situacao) {
        case 'AGUARDANDO':
          return 'orange'
        case 'ACEITO':
          return 'green'
        case 'RECUSADO':
          return 'red'
        default:
          return 'grey'
      }
    },
    handleError(message) {
      this.mostrarMensagemErro(message)
    },
    async convidarUsuario() {
      if (!this.usuarioSelecionado) return

      this.habilitarLoadingGlobal()
      this.setMensagemLoading('Enviando convite...')

      try {
        await this[actionTypes.CONVIDAR_USUARIO_PARA_RESPONDER_ESCLARECIMENTO_IMPUGNACAO]({
          esclarecimentoImpugnacaoId: this.esclarecimentoImpugnacaoId,
          usuarioId: this.usuarioSelecionado.id,
          nome: this.usuarioSelecionado.nome,
          email: this.usuarioSelecionado.email
        })

        this.mostrarMensagemSucesso('Convite enviado com sucesso')
        this.usuarioSelecionado = null
        await this.buscarUsuariosConvidados()
        this.activeTab = 1
        this.$emit('convite-enviado')
      } catch (error) {
        let mensagemErro = 'Ocorreu um erro ao enviar o convite.'

        if (error.response && error.response.data && error.response.data.message) {
          mensagemErro = error.response.data.message
        }

        this.mostrarMensagemErro(mensagemErro)
      } finally {
        this.desabilitarLoadingGlobal()
      }
    }
  }
}
</script>

<style scoped>
.modal-title {
  margin: 0;
  padding: 10px 20px;
  font-size: 18px !important;
  color: white;
}

.actions-modal {
  border-top: solid thin rgba(0, 0, 0, .12);
  padding-top: 10px;
  margin-top: 0;
}

.table-usuarios-convidados td {
  color: #777 !important;
}
</style>
